var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6546 14.408C15.5277 14.3953 15.3754 14.3953 15.2358 14.408C12.2152 14.3065 9.81641 11.8316 9.81641 8.78555C9.81641 5.67606 12.3294 3.15039 15.4516 3.15039C18.5611 3.15039 21.0867 5.67606 21.0867 8.78555C21.074 11.8316 18.6753 14.3065 15.6546 14.408Z",
    stroke: "#8B739B",
    strokeWidth: 1.67732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30747 19.0913C6.23605 21.1474 6.23605 24.498 9.30747 26.5414C12.7977 28.8767 18.5217 28.8767 22.012 26.5414C25.0834 24.4853 25.0834 21.1347 22.012 19.0913C18.5344 16.7687 12.8104 16.7687 9.30747 19.0913Z",
    stroke: "#8B739B",
    strokeWidth: 1.67732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.29aae5aabe60fc182146bdc04dfd9f1b.svg";
export { ForwardRef as ReactComponent };